import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useMerchantApi } from '../../hooks/useMerchantApi';

type InitialDataType = { storeType?: string };

export const useAllMerchant = (
  { initialData }: { initialData?: InitialDataType },
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey' | 'queryFn'>
) => {
  const { getAllMerchant } = useMerchantApi();

  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getMerchant', initialData],
    queryFn: () => getAllMerchant(initialData),
    retry: false,
    ...options, // now TypeScript won't complain
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};

// Separate query for push notifications to avoid conflicts
type PushNotificationMerchantParams = {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: string;
  search?: string;
};

export const useAllMerchantforPushNotification = (
  params: PushNotificationMerchantParams = {},
  options?: Omit<UseQueryOptions<any, Error>, 'queryKey' | 'queryFn'>
) => {
  const { getAllMerchantForPushNotification } = useMerchantApi();

  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getMerchantForPushNotification', params],
    queryFn: () => getAllMerchantForPushNotification(), // Use the dedicated push notification API function
    retry: false,
    ...options,
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
}; 